import { faCogs } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Authorization from '../../../Authentication/Authorization'
import DialogContext from '../../../Authentication/DialogContext'
import { ConfirmDialogProps } from '../../../components/ConfirmDialog'
import DataTable from '../../../components/DataTable'
import ProtectedButton from '../../../components/ProtectedButton'
import Loading from '../../../layout/Loading'
import SsoProxyService from '../../../service/SsoProxyService'

const GatewaySSOCertificates = () => {
  const { t } = useTranslation()
  const [gatewayCertificates, setGatewayCertificates] = useState({} as any)
  const [loading, setLoading] = useState(true)
  const { confirmDialogPropsSetter } = useContext(DialogContext)

  useEffect(() => {
    async function loadData() {
      const certificates = await SsoProxyService.getGatewayCertificates()
      setGatewayCertificates(certificates)
    }
    loadData().finally(() => setLoading(false))
  }, [])

  const columns = useMemo(() => {
    return [
      {
        text: 'label',
        dataField: 'label',
        classes: 'font-weight-bolder',
        sort: true,
      },
      {
        text: 'value',
        dataField: 'value',
        sort: true,
      },
    ]
  }, [])

  const data = getData()

  return (
    <Loading isLoading={loading}>
      <DataTable keyField='label' data={data} columns={columns} headerClasses='d-none' searchable={false} />
      <div className='text-right pr-1 ml-nfc-1'>
        <ProtectedButton variant='primary' className='ml-auto my-auto' onClick={generateNewCertificate} permissions={Authorization.settings.ssoProxy.edit}>
          <FontAwesomeIcon icon={faCogs} />
          <span className='ml-1 my-auto'>{t('ssoProxy.generateNewCertificate')}</span>
        </ProtectedButton>
      </div>
    </Loading>
  )

  function getData() {
    return [
      {
        label: t('ssoProxy.svcName'),
        value: gatewayCertificates.signatureValidationCertificate?.name,
      },
      {
        label: t('ssoProxy.svcSerialNumber'),
        value: gatewayCertificates.signatureValidationCertificate?.serialNumber,
      },
      {
        label: t('ssoProxy.svcExpirationDate'),
        value: gatewayCertificates.signatureValidationCertificate?.expirationDate,
      },
      {
        label: t('ssoProxy.evcName'),
        value: gatewayCertificates.encryptionValidationCertificate?.name,
      },
      {
        label: t('ssoProxy.evcSerialNumber'),
        value: gatewayCertificates.encryptionValidationCertificate?.serialNumber,
      },
      {
        label: t('ssoProxy.evcExpirationDate'),
        value: gatewayCertificates.encryptionValidationCertificate?.expirationDate,
      },
    ]
  }

  function generateNewCertificate() {
    const props: ConfirmDialogProps = {
      show: true,
      header: t('ssoProxy.generateNewCertificate'),
      onSubmit: SsoProxyService.generateGatewayCertificates,
      onSubmitExtraArgs: [t, setGatewayCertificates],
      body: t('ssoProxy.generateNewCertificateBody'),
      submitText: t('ssoProxy.generateNewCertificate'),
    }

    confirmDialogPropsSetter(props)
  }
}

export default GatewaySSOCertificates
